// custom typefaces
import "typeface-montserrat";
import "typeface-merriweather";

import {
  addGarfield,
  sendPageView,
  initialiseClientId,
} from "./src/utils/garfieldHelpers";

// custom CSS styles
export const shouldUpdateScroll = ({
  routerProps: { location },
}) => {
  // list of routes for the scroll-to-top-hook
  if (location.state?.from === "tabs") {
    return false;
  }
};

export const onClientEntry = () => {
  addGarfield();
  initialiseClientId();
  sendPageView();
};

export const onRouteUpdate = ({
  prevLocation,
  location,
}) => {
  if (prevLocation && prevLocation.href !== location.href) {
    sendPageView();
  }
};
